import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms'; 
import { SubmissionService } from '../_services/submission.service';
import { TokenStorageService } from '../_services/token-storage.service';

@Component({
  selector: 'app-submissions',
  templateUrl: './submissions.component.html'
})

export class SubmissionsComponent implements OnInit {
  contactUUID: string = "";
  searchInfo: string = "";
  submissionsList: any;
  isSearch: boolean = false;
  p: number = 0;
  limits: number = 10;
  total: number = 0;
  no_results_message: string = "";
  filter = 'all';
  loading_msg = 'Chargement en cours ';
  diplay_loading = this.loading_msg;

  searchSubmissionForm: FormGroup = new FormGroup({
    search_submission: new FormControl("")
  })

  constructor(
    private tokenStorage: TokenStorageService,
    private submissions: SubmissionService
  ) { }

  ngOnInit(): void {
    this.contactUUID = this.tokenStorage.getToken() || "";
    console.log('init...');
    this.getSubmissions();
  }

  getSubmissions() {
    console.log('getting submission, search: ', this.isSearch);
    this.isSearch = false;
    this.diplay_loading =  this.loading_msg;

    this.submissions.getSubmissions$(this.contactUUID, this.p).subscribe({
      next: (data: any) => {
        console.log('going to load all data');
        if(!this.isSearch == true) {
          console.log('loaded all data');
          this.diplay_loading = '';
          this.submissionsList = data.records;
          this.total = data.count;
        }
      },
      error: (err: any) => {
        console.log("Something went wrong fetching submissions: ", err)
      }
    })
  }

  changeFilter(btnFilter:string){
    console.log("function called", btnFilter);
    this.filter = btnFilter;
    this.getSubmissions();
    //window.open('../myURL/mypage.jsp?rurl=' + encodeURIComponent($('display').attr('href')));
  }

  pageChangeEvent(event: number){
    this.p = event - 1;

    if (this.isSearch) {
      this.searchSubmission(this.searchInfo);
    }
    else {
      this.getSubmissions();
    }
  }

  onSubmit(values: any): void {
    this.p = 0;
    console.log('submit search');
    this.searchInfo = values.search_submission;
    this.searchSubmission(this.searchInfo);
  }

  searchSubmission(search: string): void {
    console.log('getting search, search: ', this.isSearch);
    this.diplay_loading =  this.loading_msg;
    this.isSearch = true;
    this.submissions.searchSubmission$(this.contactUUID, search, this.p).subscribe({
      next: (data: any) => {
        console.log('loaded search data');
        this.diplay_loading = '';
        this.submissionsList = data.records;
        this.total = data.count;
        if(this.total == 0){ this.no_results_message = 'Aucun résultat de la recherche: ' + search;}
      },
      error: (err: any) => {
        console.log("Something went wrong searching submissions: ", err.statusText)
      }
    });
  }
}
